import CustomTable from "../../CustomTable";
import { Link } from "react-router-dom";
import { plusicon } from "../../imagepath";
import { useContext, useEffect, useState } from "react";
import {
  Modal,
  DatePicker,
  Button,
  message,
  Select,
  Skeleton,
  Popconfirm,
  Form,
} from "antd";
import moment from "moment";
import { MedicInformationContext } from "../../../context/MedicInformationContextProvider";
import { actualizarMedicamento } from "../../../services/api";
import { extractPatientIdFromUrl } from "../../../utils/helpers";
import { getWithParams, post } from "../../../services/base";
import { GestoresContext } from "../../../context/GestoresContext";
import {procedenciasCode} from "../../../utils/enums/statusCodes";

const Medicamentos = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const {
    listadoViaAdministracion,
    listadoTipos,
    listadoUnidades,
    afiliadoMedicamentos,
    listadoSustancias,
    listadoMedicamentos,
    updateMedicamentosData,
  } = useContext(MedicInformationContext);

  const { gestores } = useContext(GestoresContext);
  const [medicamentosForm] = Form.useForm();
  const [nuevoMedicamentoForm] = Form.useForm();

  const gestor = localStorage.getItem("name");
  const [loading, setLoading] = useState(true);

  const [modalNewMedicineVisible, setModalNewMedicineVisible] = useState(false);
  const [newMedicine, setNewMedicine] = useState(null);
  const [viaAdministracion, setViaAdministracion] = useState(null);
  const [tipoMedicamento, setTipoMedicamento] = useState(null);
  const [medicamentoSeleccionado, setMedicamentoSeleccionado] = useState(null);

  const [newMedicineSubstance, setNewMedicineSubstance] = useState(null);

  useEffect(() => {
    if (
      (
        listadoMedicamentos &&
        listadoViaAdministracion.length &&
        listadoTipos.length &&
        listadoUnidades.length &&
        afiliadoMedicamentos.length) >= 0
    ) {
      setLoading(false);
    }
  }, [
    listadoViaAdministracion,
    listadoTipos,
    listadoMedicamentos,
    listadoUnidades,
    afiliadoMedicamentos,
  ]);


  const handleNewMedicineInputChange = (event) => {
    const { name, value } = event.target;
    setNewMedicine(value);
  };

  const handleNewMedicineSustance = (selectedOption) => {
    console.log(selectedOption);
    setNewMedicineSubstance(selectedOption);
  };

  const handlerCancelarAnadirMedicamento = () => {
    medicamentosForm.resetFields();
    setModalVisible(false);
    setLoading(false);
  };

  const handlerCancelarNuevoMedicamento = () => {
    nuevoMedicamentoForm.resetFields();
    setModalNewMedicineVisible(false);
    setLoading(false);
  };

  const handlerAgregarNuevoMedicamento = async () => {
    nuevoMedicamentoForm
      .validateFields()
      .then(async (values) => {
        if (
          values != undefined &&
          values.errorFields != undefined &&
          values.errorFields.length > 0
        ) {
          message.error("Los campos marcados son requeridos");
          setLoading(false);
          return;
        } else {
          try {
            const formDataToSend = {
              afiliado: extractPatientIdFromUrl(),
              medicamento: newMedicine,
              tipo: tipoMedicamento,
              via: viaAdministracion,
              sustancia: newMedicineSubstance,
            };

            await post(
              "/Medicamentos/solicitar",
              JSON.stringify(formDataToSend)
            );
            message.success("Medicamento solicitado exitosamente.");
            setModalNewMedicineVisible(false);
            handlerCancelarNuevoMedicamento();
          } catch (error) {
            console.error("Error adding medicamento:", error);
            message.error(
              "Error al agregar medicamento. Por favor, inténtelo de nuevo más tarde."
            );
          }
        }
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
      });
  };

  const handleMedicamentoChange = (selectedOption) => {
    setMedicamentoSeleccionado(selectedOption);
  };

  const handleViaAdministracionChange = (selectedOption) => {
    setFormData({ ...formData, codigoViaAdministracion: selectedOption });
  };

  const handleFrecuenciaChange = (selectedOption) => {
    setFormData({ ...formData, frecuencia: selectedOption });
  };

  const handlePrescriptorChange = (selectedOption) => {
    setFormData({ ...formData, descripcionPreescriptor: selectedOption });
  };

  const handleTipoChange = (selectedOption) => {
    setFormData({ ...formData, tipo: selectedOption });
  };

  const handleFechaChange = (date) => {
    setFormData({ ...formData, fecha: date });
  };

  const handleDosisChange = (selectedOption) => {
    setFormData({ ...formData, dosis: selectedOption });
  };

  const handleActivarClick = async (medicamento) => {
    const estatus = "EST-015";
    await actualizarMedicamento(medicamento.id, estatus);
    updateMedicamentosData();
  };

  const handleCancelarClick = async (medicamento) => {
    const estatus = "EST-016";
    await actualizarMedicamento(medicamento.id, estatus);
    updateMedicamentosData();
  };

  const handleAgregar = async () => {
    medicamentosForm
      .validateFields()
      .then(async (values) => {
        if (
          values != undefined &&
          values.errorFields != undefined &&
          values.errorFields.length > 0
        ) {
          message.error("Los campos marcados son requeridos");
          setLoading(false);
          return;
        } else {
          try {
            setLoading(true);
            const formDataToSend = {
              codigoAfiliado: extractPatientIdFromUrl(),
              codigo: medicamentoSeleccionado.toString(),
              dosis: formData.dosis,
              codigoUnidadMedidad: "UM-0023",
              codigoViaAdministracion: formData.codigoViaAdministracion
                ? formData.codigoViaAdministracion.toString()
                : null,
              frecuencia: formData.frecuencia,
              descripcionPreescriptor: formData.descripcionPreescriptor
                ? formData.descripcionPreescriptor
                : gestor,
              fechaAutorizacion: moment().format("YYYY-MM-DD"),
            };

            await post("/Medicamentos", JSON.stringify(formDataToSend));
            updateMedicamentosData();
            handlerCancelarAnadirMedicamento();
            message.success("Medicamento agregado exitosamente.");
          } catch (error) {
            console.error("Error adding medicamento:", error);
            message.error(
              "Error al agregar medicamento. Por favor, inténtelo de nuevo más tarde."
            );
          }
        }
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
      });
  };

  const frecuencias = [
    { value: 8, label: "Cada 8 horas" },
    { value: 12, label: "Cada 12 horas" },
    { value: 24, label: "Cada 24 horas" },
  ];
  const handleButtonClick = (record) => {
    const { dosis, viaAdministracion, frecuencia } = record;

    Modal.info({
      title: "Detalles del Medicamento",
      content: (
        <div>
          <p>
            <strong>Dosis:</strong> {dosis}
          </p>
          <p>
            <strong>Vía de Administración:</strong> {viaAdministracion}
          </p>
          <p>
            <strong>Frecuencia:</strong> {frecuencia}h
          </p>
        </div>
      ),
      onOk() {},
      centered: true,
    });
  };
  const columns = [
    {
      title: "Medicamento",
      dataIndex: "medicamento",
      key: "medicamento",
      sorter: (a, b) => a.medicamento.localeCompare(b.Medicamento),
      searchable: true,
    },
    {
      title: "Autorizacion",
      dataIndex: "autorizacion",
      key: "autorizacion",
      sorter: (a, b) => a.autorizacion.localeCompare(b.Autorizacion),
      searchable: true,
    },
    {
      title: "Ver Patología",
      dataIndex: "verPatologia",
      key: "verPatologia",
      render: (text, record) => (
        <Button
          type="link"
          className="btn btn-primary"
          style={{
            backgroundColor: "var(--mint-green)",
            borderColor: "var(--mint-green)",
          }}
          onClick={() => handleButtonClick(record)}
        >
          Ver Patología
        </Button>
      ),
    },
    {
      title: "Preescriptor",
      dataIndex: "prescriptor",
      key: "prescriptor",
      sorter: (a, b) => a.address.localeCompare(b.Preescriptor),
      searchable: true,
    },
    {
      title: "Gestor",
      dataIndex: "gestor",
      key: "gestor",
      sorter: (a, b) => a.gestor.localeCompare(b.Gestor),
      searchable: true,
    },
    {
      title: "Estatus",
      dataIndex: "estatus",
      key: "estatus",
      sorter: (a, b) => a.estatus.localeCompare(b.estatus),
      render: (text, record) => (
        <Popconfirm
          title={`¿Estás seguro que deseas ${
            record.estatus === "Inactivo" ? "activar" : "inactivar"
          } este medicamento?`}
          onConfirm={() =>
            record.estatus === "Inactivo"
              ? handleActivarClick(record)
              : handleCancelarClick(record)
          }
          okText="Sí"
          cancelText="No"
        >
          <Button
            type="link"
            className="btn btn-primary"
            style={{
              backgroundColor:
                record.estatus === "Inactivo" ? "#ff9999" : "var(--mint-green)",
              borderColor:
                record.estatus === "Inactivo" ? "#ff9999" : "var(--mint-green)",
            }}
          >
            {record.estatus === "Inactivo" ? "Inactiva" : "Activa"}
          </Button>
        </Popconfirm>
      ),
    },
    {
      title: "Fuente",
      dataIndex: "fuente",
      key: "fuente",
      sorter: (a, b) => a.fuente.localeCompare(b.Fuente),
      searchable: true,
    },
  ];

  const [formData, setFormData] = useState({
    examen: "",
    actividadDe: "",
    fechaToma: null,
    dosis: null,
    medicamento : null
  });
  const handleClosePreviousModal = () => {
    setModalVisible(false);
  };

  const handleOpenModalAndClosePrevious = () => {
    handleClosePreviousModal();
    setModalNewMedicineVisible(true);
  };

  const rowSelection = {
  };


  return (
    <div className="card">
      <div className="card-header pb-0">
        <h4 className="card-title d-inline-block">Tratamiento Farmacológico</h4>{" "}
      </div>
      {loading ? (
        <Skeleton active />
      ) : (
        <CustomTable
          dataSource={afiliadoMedicamentos}
          columns={columns}
          rowSelection={rowSelection}
          contexto={procedenciasCode.Medicamento.value}
          updateDataSource={
            updateMedicamentosData == undefined ? {} : updateMedicamentosData
          }
        />
      )}
      <Link
        to="#"
        onClick={() => setModalVisible(true)}
        className="btn btn-primary add-pluss ms-2"
      >
        <img src={plusicon} alt="#" />
        Agregar
      </Link>
      <Modal
        title="Agregar Tratamiento Farmacológico"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={handlerCancelarAnadirMedicamento}>
            Cancelar
          </Button>,
          <Button key="solicitar" onClick={handleOpenModalAndClosePrevious}>
            Solicitar nuevo medicamento
          </Button>,
          <Button
            key="submit"
            loading={loading}
            type="primary"
            onClick={handleAgregar}
          >
            Agregar
          </Button>,
        ]}
        centered
        style={{
          zIndex: 1042,
        }}
      >
        <div className="row">
          <div className="col-sm-12">
            <br></br>
            <Form form={medicamentosForm}>
              <div className="row">
                <div className="col-12 col-md-6 col-xl-12">
                  <div className="form-group local-forms">
                  <label htmlFor="medicamento">Medicamento</label>
                    <Form.Item
                      name={"Medicamento"}
                      rules={[{ required: true, message: "Es requerido" }]}
                    >
                      <Select
                        id="buscar-medicamento"
                        style={{ width: "100%" }}
                        value={medicamentoSeleccionado}
                        onChange={handleMedicamentoChange}
                        showSearch
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {listadoMedicamentos &&
                            listadoMedicamentos.length > 0 &&
                            listadoMedicamentos.map((medicamento) => (
                              <Option key={medicamento.id} value={medicamento.id}>
                                {medicamento.descripcion}
                              </Option>
                            ))}
                      </Select>
                    </Form.Item>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-6 col-xl-6">
                    <div className="form-group local-forms">
                      <label>
                        Vía de administración{" "}
                        <span className="login-danger">*</span>
                      </label>
                      <Form.Item
                        name={"Via de administracion"}
                        rules={[{ required: true, message: "Es requerida" }]}
                      >
                        <Select
                          id="buscar-administracion"
                          style={{ width: "100%" }}
                          value={formData.codigoViaAdministracion}
                          onChange={handleViaAdministracionChange}
                        >
                          {listadoViaAdministracion &&
                            listadoViaAdministracion.length > 0 &&
                            listadoViaAdministracion.map((via) => (
                              <Option key={via.codigo} value={via.codigo}>
                                {via.descripcion}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-xl-6">
                    <div className="form-group local-forms">
                      <label>
                        Frecuencia <span className="login-danger">*</span>
                      </label>
                      <Form.Item
                        name={"Frecuencia"}
                        rules={[{ required: true, message: "Es requerida" }]}
                      >
                        <Select
                          id="buscar-frecuencia"
                          style={{ width: "100%" }}
                          value={formData.frecuencia}
                          onChange={handleFrecuenciaChange}
                        >
                          {frecuencias &&
                            frecuencias.length > 0 &&
                            frecuencias.map((frecuencia) => (
                              <Option
                                key={"frec_" + frecuencia.key}
                                value={frecuencia.value}
                              >
                                {frecuencia.label}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-6 col-xl-6">
                    <div className="form-group local-forms">
                      <label>
                        Prescriptor <span className="login-danger">*</span>
                      </label>
                      <Select
                        id="buscar-preescriptor"
                        style={{ width: "100%" }}
                        value={formData.descripcionPreescriptor}
                        defaultValue={
                          gestor ? { value: gestor, label: gestor } : null
                        }
                        onChange={handlePrescriptorChange}
                      >
                        {gestores &&
                          gestores.length > 0 &&
                          gestores.map((gestor) => (
                            <Option key={gestor.gestor} value={gestor.gestor}>
                              {gestor.gestor}
                            </Option>
                          ))}
                      </Select>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-xl-6">
                    <div className="form-group local-forms">
                      <label>
                        Tipo <span className="login-danger">*</span>
                      </label>
                      <Form.Item
                        name={"Tipo"}
                        rules={[{ required: true, message: "Es requerido" }]}
                      >
                        <Select
                          id="buscar-preescriptor"
                          style={{ width: "100%" }}
                          value={formData.tipo}
                          onChange={handleTipoChange}
                        >
                          {listadoTipos &&
                            listadoTipos.length > 0 &&
                            listadoTipos.map((tipo) => (
                              <Option key={tipo.id} value={tipo.id}>
                                {tipo.descripcion}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12">
                  <div className="form-group local-forms">
                    <label>
                      Dosis <span className="login-danger">*</span>
                    </label>
                    {/* <input
                                className="form-control"
                                type="number"
                                value={formData.dosis}
                                onChange={(e) => setFormData({ ...formData, dosis: e.target.value })}
                                placeholder=""
                              /> */}
                    <Form.Item
                      name={"Dosis"}
                      rules={[{ required: true, message: "Es requerida" }]}
                    >
                      <Select
                        id="buscar-preescriptor"
                        style={{ width: "100%" }}
                        value={formData.dosis}
                        onChange={handleDosisChange}
                      >
                        {listadoUnidades &&
                          listadoUnidades.length > 0 &&
                          listadoUnidades.map((uni) => (
                            <Option key={uni.id} value={uni.id}>
                              {uni.descripcion}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-xl-12">
                  <div className="form-group local-forms cal-icon">
                    <label>
                      Fecha <span className="login-danger">*</span>
                    </label>
                    <Form.Item
                      name={"Fecha"}
                      rules={[{ required: true, message: "Es requerida" }]}
                    >
                      <DatePicker
                        placeholder=""
                        className="form-control datetimepicker"
                        onChange={handleFechaChange}
                        suffixIcon={null}
                      />
                    </Form.Item>
                    {/* <input
                                      className="form-control datetimepicker"
                                      type="text"
                                  /> */}
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </Modal>

      <Modal
        title="Solicitar nuevo medicamento"
        open={modalNewMedicineVisible}
        onCancel={() => handlerCancelarNuevoMedicamento(false)}
        footer={[
          <Button
            key="cancel"
            onClick={() => handlerCancelarNuevoMedicamento(false)}
          >
            Cancelar
          </Button>,
          <Button
            key="add"
            type="primary"
            loading={loading}
            onClick={handlerAgregarNuevoMedicamento}
          >
            Solicitar
          </Button>,
        ]}
        centered
      >
        <Form form={nuevoMedicamentoForm}>
          <div className="row">
            <div className="col-12 col-md-6 col-xl-12">
              <div className="form-group local-forms">
                <label>
                  Medicamento <span className="login-danger">*</span>
                </label>
                <Form.Item
                  name={"Medicamento"}
                  rules={[{ required: true, message: "Es requerido" }]}
                >
                  <input
                    className="form-control"
                    type="text"
                    x
                    onChange={handleNewMedicineInputChange}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="col-12 col-md-6 col-xl-12">
              <div className="form-group local-forms">
                <label>
                  Via Administracion <span className="login-danger">*</span>
                </label>
                <Form.Item
                  name={"Via Administracion"}
                  rules={[{ required: true, message: "Es requerida" }]}
                >
                  <Select
                    id="viaAdministracion"
                    style={{ width: "100%" }}
                    onChange={setViaAdministracion}
                    options={listadoViaAdministracion.map((via) => ({
                      value: via.codigo,
                      label: via.descripcion,
                    }))}
                    menuPortalTarget={document.body}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-6 col-xl-6">
                <div className="form-group local-forms">
                  <label>
                    Tipo <span className="login-danger">*</span>
                  </label>
                  <Form.Item
                    name={"Tipo"}
                    rules={[{ required: true, message: "Es requerido" }]}
                  >
                    <Select
                      id="tipoMedicamento"
                      style={{ width: "100%" }}
                      onChange={setTipoMedicamento}
                      options={listadoTipos.map((tipo) => ({
                        value: tipo.codigo,
                        label: tipo.descripcion,
                      }))}
                      menuPortalTarget={document.body}
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="col-12 col-md-6 col-xl-6">
                <div className="form-group local-forms">
                  <label>
                    Sustancia <span className="login-danger">*</span>
                  </label>
                  <Form.Item
                    name={"Sustancia"}
                    rules={[{ required: true, message: "Es requerida" }]}
                  >
                    <Select
                      id="medicineSubstance"
                      style={{ width: "100%" }}
                      onChange={handleNewMedicineSustance}
                      options={listadoSustancias && listadoSustancias.map((sustancia) => ({
                        value: sustancia.value,
                        label: sustancia.label,
                      }))}
                      menuPortalTarget={document.body}
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default Medicamentos;
